"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var FlexView_1 = require("../FlexView/FlexView");
var Icon_1 = require("../Icon");
var Item = function (_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b, props = __rest(_a, ["active"]);
    var renderInnerElements = function () {
        if (props.icon === undefined) {
            return props.children;
        }
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(FlexView_1.FlexView, __assign({ vAlignContent: "center" }, { children: (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ grow: true, xs: 11, md: 10, xl: 11 }, { children: props.children })) })), (0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: "icon-right", icon: "icon_alert-circle", size: "std" })] }));
    };
    if (props.real) {
        return ((0, jsx_runtime_1.jsx)("li", __assign({ className: "side-menu-item" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: props.to, className: "".concat(active ? 'active' : '', " content") }, { children: renderInnerElements() })) })));
    }
    return ((0, jsx_runtime_1.jsx)("li", __assign({ className: "side-menu-item" }, { children: (0, jsx_runtime_1.jsx)(props.NavComponent, __assign({ to: props.to, exact: "true", end: true, className: function (_a) {
                var isActive = _a.isActive;
                return "".concat(isActive ? 'active' : '', " content");
            } }, { children: renderInnerElements() })) })));
};
exports.Item = Item;
//# sourceMappingURL=Item.js.map